import React, { useEffect, useState } from "react";
import { clientApi } from "../lib/api";
import { Users, GraduationCap, DollarSign, Baby, MapPin } from "lucide-react";

const fmtInt = (n) => new Intl.NumberFormat("pt-BR").format(n || 0);
const fmtBRL = (n) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(n || 0);

const UFS = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

export default function IBGE() {
  const [uf, setUf] = useState("GO");
  const [municipio, setMunicipio] = useState("Goiânia");
  const [data, setData] = useState(null);

  const load = () => clientApi.get("/ibge", { params: { uf, municipio } }).then(({ data }) => setData(data));
  useEffect(() => { load(); }, []);

  const d = data?.data || (data?.source === "ibge" ? null : data);

  return (
    <div className="space-y-6" data-testid="cliente-ibge-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-accent-orange mb-1">Dados Demográficos</div>
        <h1 className="font-display text-3xl md:text-4xl">IBGE · Painel Territorial {data?.source === "demo" && <span className="text-xs text-neutral-500 lowercase tracking-widest">(demo)</span>}</h1>
        <p className="text-sm text-neutral-400 mt-2">Consulta a dados demográficos oficiais para embasar decisões estratégicas de posicionamento e produto.</p>
      </div>

      <div className="border border-white/10 rounded-xl p-4 bg-white/[0.02] flex gap-3 items-end flex-wrap">
        <div>
          <label className="text-[10px] uppercase tracking-widest text-neutral-500">UF</label>
          <select value={uf} onChange={(e) => setUf(e.target.value)} className="bg-black border border-white/10 rounded-lg px-3 py-2 text-sm mt-1">
            {UFS.map((u) => <option key={u} value={u}>{u}</option>)}
          </select>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-widest text-neutral-500">Município</label>
          <input value={municipio} onChange={(e) => setMunicipio(e.target.value)} className="bg-black border border-white/10 rounded-lg px-3 py-2 text-sm mt-1" />
        </div>
        <button onClick={load} className="bg-accent-orange text-white text-xs font-bold px-4 py-2.5 rounded-full">Consultar</button>
      </div>

      {d && (
        <div className="grid md:grid-cols-2 gap-4">
          <Card icon={Users} label="População estimada" value={fmtInt(d.populacao_estimada)} accent="text-blue-400" />
          <Card icon={MapPin} label="Densidade hab/km²" value={fmtInt(d.densidade_hab_km2)} accent="text-purple-400" />
          <Card icon={GraduationCap} label="IDH" value={d.idh} accent="text-accent-yellow" />
          <Card icon={DollarSign} label="Renda média domicílios" value={fmtBRL(d.renda_media_domicilios)} accent="text-green-400" />
        </div>
      )}

      {d?.faixa_etaria && (
        <div className="border border-white/10 rounded-xl p-6 bg-white/[0.02]">
          <div className="text-xs uppercase tracking-widest text-accent-orange mb-4 flex items-center gap-2"><Baby className="w-3 h-3" /> Faixa Etária</div>
          <div className="space-y-2">
            {Object.entries(d.faixa_etaria).map(([faixa, pct]) => (
              <div key={faixa}>
                <div className="flex justify-between text-xs mb-1"><span className="text-neutral-400">{faixa} anos</span><span className="font-semibold">{pct}%</span></div>
                <div className="h-2 bg-white/5 rounded overflow-hidden"><div className="h-full bg-gradient-to-r from-accent-orange to-accent-yellow" style={{ width: `${pct * 2}%` }} /></div>
              </div>
            ))}
          </div>
        </div>
      )}

      {data?.source === "ibge" && data.municipios && (
        <div className="border border-white/10 rounded-xl p-6 bg-white/[0.02]">
          <div className="text-xs uppercase tracking-widest text-accent-orange mb-3">{data.municipios_count} municípios em {data.uf}</div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 text-xs max-h-64 overflow-y-auto no-scrollbar">
            {data.municipios.map((m) => <div key={m.id} className="text-neutral-300 truncate">{m.nome}</div>)}
          </div>
        </div>
      )}

      <div className="text-[11px] text-neutral-500 text-center border-t border-white/5 pt-4">
        Fonte: <b>IBGE</b> · dados públicos oficiais.
      </div>
    </div>
  );
}

function Card({ icon: Icon, label, value, accent }) {
  return (
    <div className="border border-white/10 rounded-xl p-5 bg-white/[0.02]">
      <div className={`w-9 h-9 rounded-lg bg-black/40 flex items-center justify-center mb-3 ${accent}`}><Icon className="w-4 h-4" /></div>
      <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1">{label}</div>
      <div className="font-display text-3xl">{value}</div>
    </div>
  );
}
